module.exports = __webpack_public_path__ + "public/srwrds-flare-tierup.png";